// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Jgxus","description":"PatientConsentPreview_description__2zKXE"};